import React, { useState, useEffect, useContext } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { UserContext } from "../contexts/UserContext";
import { MdDelete, MdAdd } from "react-icons/md";
import { FaFileUpload } from "react-icons/fa";
import PricingModal from "./PricingModal";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const uid = () => Math.random().toString(36).slice(2);

// ─── Estilos inline ────────────────────────────────────────────────────────────
const S = {
  page: {
    minHeight: "100vh",
    background: "#f7f4f6",
    padding: "32px 16px",
    fontFamily: "'Segoe UI', system-ui, sans-serif",
  },
  card: {
    maxWidth: 900,
    margin: "0 auto",
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 2px 24px rgba(159,0,89,0.08)",
    overflow: "hidden",
  },
  header: {
    background: "#9f0059",
    padding: "24px 32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  headerTitle: {
    color: "#fff",
    fontSize: 22,
    fontWeight: 700,
    margin: 0,
    letterSpacing: "-0.3px",
  },
  headerSub: {
    color: "rgba(255,255,255,0.7)",
    fontSize: 13,
    marginTop: 2,
  },
  body: { padding: "28px 32px" },
  section: { marginBottom: 28 },
  sectionTitle: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    color: "#9f0059",
    marginBottom: 12,
    paddingBottom: 6,
    borderBottom: "1.5px solid #f0e6ec",
  },
  grid2: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 },
  fieldGroup: { display: "flex", flexDirection: "column", gap: 4 },
  label: { fontSize: 12, fontWeight: 600, color: "#555", letterSpacing: "0.02em" },
  input: {
    padding: "9px 12px",
    border: "1.5px solid #e0d6dc",
    borderRadius: 8,
    fontSize: 14,
    color: "#121212",
    background: "#fafafa",
    outline: "none",
  },
  select: {
    padding: "9px 12px",
    border: "1.5px solid #e0d6dc",
    borderRadius: 8,
    fontSize: 14,
    color: "#121212",
    background: "#fafafa",
    outline: "none",
    cursor: "pointer",
    width: "100%",
  },
  textarea: {
    padding: "9px 12px",
    border: "1.5px solid #e0d6dc",
    borderRadius: 8,
    fontSize: 14,
    color: "#121212",
    background: "#fafafa",
    outline: "none",
    resize: "vertical",
    minHeight: 72,
    fontFamily: "inherit",
    width: "100%",
    boxSizing: "border-box",
  },
  tableWrap: { border: "1.5px solid #f0e6ec", borderRadius: 10, overflow: "hidden" },
  table: { width: "100%", borderCollapse: "collapse" },
  th: {
    background: "#fdf0f6",
    padding: "10px 12px",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#9f0059",
    textAlign: "left",
    borderBottom: "1.5px solid #f0e6ec",
  },
  td: { padding: "8px 10px", borderBottom: "1px solid #f5f0f3", verticalAlign: "middle" },
  tdInput: {
    padding: "6px 8px",
    border: "1.5px solid #e0d6dc",
    borderRadius: 6,
    fontSize: 13,
    width: "100%",
    background: "#fff",
    boxSizing: "border-box",
    outline: "none",
    color: "#121212",
  },
  addRowBtn: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: "10px 16px",
    background: "transparent",
    border: "1.5px dashed #c990b0",
    borderRadius: 8,
    color: "#9f0059",
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
    marginTop: 10,
  },
  deleteBtn: {
    background: "none",
    border: "none",
    color: "#c0396a",
    cursor: "pointer",
    padding: 4,
    display: "flex",
    alignItems: "center",
    borderRadius: 4,
  },
  fileZone: {
    border: "1.5px dashed #c990b0",
    borderRadius: 10,
    padding: "16px 20px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: 10,
    color: "#9f0059",
    fontSize: 13,
    fontWeight: 600,
    background: "#fdf5fa",
  },
  fileList: { display: "flex", flexWrap: "wrap", gap: 8, marginTop: 10 },
  fileChip: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 10px",
    background: "#f0e6ec",
    borderRadius: 20,
    fontSize: 12,
    color: "#9f0059",
    fontWeight: 500,
  },
  footer: {
    padding: "20px 32px",
    background: "#fdf0f6",
    borderTop: "1.5px solid #f0e6ec",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  total: { fontSize: 20, fontWeight: 700, color: "#9f0059" },
  totalLabel: { fontSize: 12, color: "#888", marginBottom: 2 },
  btnPrimary: {
    padding: "11px 28px",
    background: "#9f0059",
    color: "#fff",
    border: "none",
    borderRadius: 9,
    fontSize: 15,
    fontWeight: 700,
    cursor: "pointer",
    letterSpacing: "-0.2px",
  },
  btnSecondary: {
    padding: "11px 22px",
    background: "transparent",
    color: "#9f0059",
    border: "1.5px solid #c990b0",
    borderRadius: 9,
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    marginRight: 10,
  },
  // Bundle styles
  bundleHeader: (color) => ({
    background: color || "#9f0059",
    padding: "10px 14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: "8px 8px 0 0",
  }),
  bundleHeaderText: {
    color: "#fff",
    fontWeight: 700,
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  bundleWrap: {
    border: "1.5px solid #e0d6dc",
    borderRadius: 10,
    overflow: "hidden",
    marginBottom: 16,
  },
  bundleDateRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "8px 14px",
    background: "#fdf0f6",
    borderBottom: "1px solid #f0e6ec",
  },
  bundleDateList: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    marginTop: 10,
  },
  bundleDateItem: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    background: "#fdf5fa",
    border: "1.5px solid #e8d0de",
    borderRadius: 8,
    padding: "8px 12px",
  },
};

const emptyItem = () => ({
  _key: uid(),
  category: "",
  description: "",
  quantity: "",
  price: "",
  number: "",
  observations: "",
  esEscala: false,
  escalones: [],
});

const emptyEscalon = () => ({ _k: uid(), cantidad: "", precio: "" });

// ─── Sub-componente ItemRow ─────────────────────────────────────────────────────
// Botón "⚡ precio de lista" (motor de precios — solo separadores, ARS)
const pricingBtnStyle = {
  border: "1.5px solid #f0c6df", background: "#fdf5fa", color: "#9f0059",
  borderRadius: 6, padding: "3px 6px", fontSize: 12, cursor: "pointer", lineHeight: 1,
};

const ItemRow = ({
  it, categories, canDelete, onUpdate, onDelete,
  onToggleEscala, onAddEscalon, onRemoveEscalon, onUpdateEscalon,
  showPricing, onPricing,
}) => (
  <>
    <tr>
      <td style={{ ...S.td, minWidth: 140 }}>
        <select
          style={{ ...S.tdInput, minWidth: 130 }}
          value={it.category}
          onChange={(e) => onUpdate("category", e.target.value)}
        >
          <option value="">Categoría</option>
          {categories.map((c) => (
            <option key={c.id} value={c.id}>{c.categoria}</option>
          ))}
        </select>
      </td>
      <td style={{ ...S.td, minWidth: 180 }}>
        <input
          style={{ ...S.tdInput, minWidth: 170 }}
          type="text"
          placeholder="Descripción del producto"
          value={it.description}
          onChange={(e) => onUpdate("description", e.target.value)}
        />
      </td>
      <td style={{ ...S.td, width: 70 }}>
        {it.esEscala ? (
          <span style={{ fontSize: 11, color: "#9f0059", fontWeight: 600 }}>escala</span>
        ) : (
          <input
            style={{ ...S.tdInput, width: 60 }}
            type="number"
            min="0"
            placeholder="0"
            value={it.quantity}
            onChange={(e) => onUpdate("quantity", e.target.value)}
          />
        )}
      </td>
      <td style={{ ...S.td, width: 90 }}>
        {it.esEscala ? (
          <span style={{ fontSize: 11, color: "#bbb" }}>—</span>
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <input
              style={{ ...S.tdInput, width: 80 }}
              type="number"
              min="0"
              step="0.01"
              placeholder="0.00"
              value={it.price}
              onChange={(e) => onUpdate("price", e.target.value)}
            />
            {showPricing && (
              <button type="button" style={pricingBtnStyle} title="Completar con precio de lista"
                onClick={() => onPricing(null, it.quantity)}>
                ⚡
              </button>
            )}
          </div>
        )}
      </td>
      <td style={{ ...S.td, width: 100 }}>
        <input
          style={{ ...S.tdInput, width: 90 }}
          type="text"
          placeholder="—"
          value={it.number}
          onChange={(e) => onUpdate("number", e.target.value)}
        />
      </td>
      <td style={{ ...S.td, minWidth: 120 }}>
        <input
          style={{ ...S.tdInput, minWidth: 110 }}
          type="text"
          placeholder="Notas..."
          value={it.observations}
          onChange={(e) => onUpdate("observations", e.target.value)}
        />
      </td>
      <td style={{ ...S.td, width: 36 }}>
        {canDelete && (
          <button style={S.deleteBtn} title="Eliminar fila" onClick={onDelete}>
            <MdDelete size={18} />
          </button>
        )}
      </td>
    </tr>
    <tr>
      <td colSpan={7} style={{ padding: "0 8px 10px", borderBottom: "1px solid #f0e6ec" }}>
        <label style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12, color: "#9f0059", cursor: "pointer", fontWeight: 600 }}>
          <input type="checkbox" checked={it.esEscala} onChange={() => onToggleEscala()} />
          ⚖ Cotización en escala
        </label>
        {it.esEscala && (
          <div style={{ marginTop: 8, background: "#fdf5fa", border: "1.5px solid #e8d0de", borderRadius: 8, padding: "10px 12px" }}>
            <div style={{ fontSize: 11, color: "#888", marginBottom: 6 }}>
              Tramos de cantidad y precio (mismo producto). No suma al total de la cotización.
            </div>
            {it.escalones.map((esc) => (
              <div key={esc._k} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                <input
                  style={{ ...S.tdInput, width: 90 }}
                  type="number" min="0" placeholder="Cantidad"
                  value={esc.cantidad}
                  onChange={(e) => onUpdateEscalon(esc._k, "cantidad", e.target.value)}
                />
                <span style={{ color: "#bbb" }}>→</span>
                <input
                  style={{ ...S.tdInput, width: 110 }}
                  type="number" min="0" step="0.01" placeholder="Precio unit."
                  value={esc.precio}
                  onChange={(e) => onUpdateEscalon(esc._k, "precio", e.target.value)}
                />
                {showPricing && (
                  <button type="button" style={pricingBtnStyle} title="Completar con precio de lista"
                    onClick={() => onPricing(esc._k, esc.cantidad)}>
                    ⚡
                  </button>
                )}
                <button style={S.deleteBtn} title="Quitar tramo" onClick={() => onRemoveEscalon(esc._k)}>
                  <MdDelete size={16} />
                </button>
              </div>
            ))}
            <button
              type="button"
              onClick={() => onAddEscalon()}
              style={{ display: "inline-flex", alignItems: "center", gap: 4, background: "none", border: "1.5px dashed #9f0059", color: "#9f0059", borderRadius: 6, padding: "4px 10px", fontSize: 12, cursor: "pointer", fontWeight: 600 }}
            >
              <MdAdd size={14} /> Agregar escalón
            </button>
          </div>
        )}
      </td>
    </tr>
  </>
);

const ItemTableHeader = () => (
  <thead>
    <tr>
      {["Categoría", "Descripción", "Cant.", "Precio", "N° Plano", "Obs.", ""].map((h) => (
        <th key={h} style={S.th}>{h}</th>
      ))}
    </tr>
  </thead>
);

// ─── Componente principal ──────────────────────────────────────────────────────
const NewQuotation = () => {
  const { user } = useContext(UserContext);
  const history = useHistory();
  const location = useLocation();
  const { orderId } = useParams();
  const editMode = !!orderId;

  // Si vino desde "Aceptar" en Solicitudes de Cotización, traemos el id por query string.
  // Al guardar exitosamente, marcamos esa solicitud como aceptada.
  const solicitudId = new URLSearchParams(location.search).get("solicitud");

  const [clients, setClients] = useState([]);
  const [providers, setProviders] = useState([]);
  const [categories, setCategories] = useState([]);
  const [contacts, setContacts] = useState([]);

  const [inputClient, setInputClient] = useState("");
  const [inputProvider, setInputProvider] = useState("");
  const [inputContact, setInputContact] = useState("");
  const [inputObservations, setInputObservations] = useState("");
  const [files, setFiles] = useState([]);
  const [items, setItems] = useState([emptyItem()]);
  const [submitting, setSubmitting] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(editMode);

  // ── Motor de precios (separadores) ─────────────────────────────────────────
  const [pricingCategoriaId, setPricingCategoriaId] = useState(null);
  const [pricingTarget,      setPricingTarget]      = useState(null); // { itemKey, escalonKey|null, cantidad }

  // ── Extracción IA (leer archivo del proveedor) ────────────────────────────
  const [docExtraer,      setDocExtraer]      = useState(null);
  const [extrayendo,      setExtrayendo]      = useState(false);
  const [extractedFields, setExtractedFields] = useState(new Set());
  const aiStyle = (field) =>
    extractedFields.has(field) ? { outline: "2px solid #16a34a", borderColor: "#16a34a" } : {};
  const clearExtracted = (field) =>
    setExtractedFields((prev) => {
      if (!prev.has(field)) return prev;
      const next = new Set(prev); next.delete(field); return next;
    });

  // ── Estado de moneda (solo modo creación) ─────────────────────────────────
  const [moneda,     setMoneda]     = useState("ARS");
  const [tipoCambio, setTipoCambio] = useState("");
  const [loadingTC,  setLoadingTC]  = useState(false);
  const [tcFecha,    setTcFecha]    = useState("");

  // ── Carga de listas base ───────────────────────────────────────────────────
  useEffect(() => {
    axios.post(`${BASE}/buscar_terceros.php`).then((r) => {
      setClients(r.data.filter((x) => x.tipo_other === 2));
      setProviders(r.data.filter((x) => x.tipo_other === 3));
    }).catch(() => toast.error("No se pudieron cargar clientes/proveedores."));

    axios.post(`${BASE}/buscar_categorias.php`)
      .then((r) => setCategories(r.data))
      .catch(() => toast.error("No se pudieron cargar las categorías."));

    // Categoría habilitada para el motor de precios (separadores). Fail-silent:
    // si la config no existe todavía, simplemente no aparece el botón ⚡.
    axios.post(`${BASE}/pricing_config_listar.php`)
      .then((r) => { if (r.data?.success && r.data.pricing_categoria_id) setPricingCategoriaId(r.data.pricing_categoria_id); })
      .catch(() => {});
  }, []);

  // ── Carga de contactos al cambiar cliente ─────────────────────────────────
  useEffect(() => {
    if (!inputClient) { setContacts([]); setInputContact(""); return; }
    axios.post(`${BASE}/crm_contactos_listar.php`, new URLSearchParams({ cliente_id: inputClient }))
      .then((r) => setContacts(Array.isArray(r.data) ? r.data : []))
      .catch(() => setContacts([]));
  }, [inputClient]);

  // ── Pre-carga desde solicitud (cuando vino del tab "Solicitudes") ─────────
  useEffect(() => {
    if (!solicitudId || editMode) return;
    axios.post(`${BASE}/solicitudes_obtener.php`, new URLSearchParams({ id: solicitudId }))
      .then((r) => {
        const s = r.data;
        if (!s || s.error) return;
        if (s.cliente_id)    setInputClient(String(s.cliente_id));
        if (s.proveedor_id)  setInputProvider(String(s.proveedor_id));
        if (s.observaciones) setInputObservations(s.observaciones);
        if (s.contacto_id)   setInputContact(String(s.contacto_id));
      })
      .catch(() => toast.error("No se pudo cargar la solicitud."));
  }, [solicitudId, editMode]);

  // ── Carga de datos existentes (modo edición) ───────────────────────────────
  useEffect(() => {
    if (!editMode) return;

    axios.post(`${BASE}/getOrderDetails.php`, new URLSearchParams({ orderId }))
      .then((detRes) => {
        const det = detRes.data;

        if (det && det.cliente_id != null) {
          setInputClient(String(det.cliente_id));
          setInputProvider(String(det.proveedor_id));
          setInputObservations(det.observaciones ?? "");
          setFiles(det.archivos || []);
          if (det.contacto_id) setInputContact(String(det.contacto_id));
        }

        const itmList = det?.items ?? [];
        if (itmList.length > 0) {
          setItems(itmList.map((it) => ({
            _key:         uid(),
            category:     String(it.categoria_id ?? ""),
            description:  it.descripcion ?? "",
            quantity:     String(it.cantidad ?? ""),
            price:        String(it.precio ?? ""),
            number:       "",
            observations: "",
            esEscala:     !!Number(it.es_escala),
            escalones:    Array.isArray(it.escalones)
              ? it.escalones.map((e) => ({ _k: uid(), cantidad: String(e.cantidad ?? ""), precio: String(e.precio ?? "") }))
              : [],
          })));
        } else if (det && det.cliente_id != null) {
          // La cotización existe pero no tiene ítems en la BD
          // (pueden haberse perdido por un error previo — NO resetear el estado de items
          //  para que el usuario pueda agregarlos manualmente sin perder el encabezado)
          toast.error("⚠ Esta cotización no tiene productos guardados. Podés agregarlos manualmente.", { autoClose: 8000 });
        }
      })
      .catch((err) => {
        console.error("[edit] error cargando cotización:", err);
        toast.error("Error al cargar la cotización.");
      })
      .finally(() => setLoadingEdit(false));
  }, [orderId]);

  // ── Tipo de cambio BNA ────────────────────────────────────────────────────
  const fetchTipoCambio = async () => {
    setLoadingTC(true);
    try {
      const r = await axios.get(`${BASE}/get_tipo_cambio_bna.php`);
      if (r.data?.success) {
        setTipoCambio(String(r.data.venta));
        setTcFecha(r.data.fecha);
      } else {
        toast.error(r.data?.mensaje || "No se pudo obtener el tipo de cambio.");
      }
    } catch {
      toast.error("Error al consultar el tipo de cambio BNA.");
    } finally {
      setLoadingTC(false);
    }
  };

  const handleMonedaChange = (newMoneda) => {
    setMoneda(newMoneda);
    if (newMoneda === "USD" && !tipoCambio) fetchTipoCambio();
    if (newMoneda === "ARS") { setTipoCambio(""); setTcFecha(""); }
  };

  // ── Helpers de ítems (modo simple) ────────────────────────────────────────
  const updateItem = (key, field, value) =>
    setItems((prev) => prev.map((it) => (it._key === key ? { ...it, [field]: value } : it)));
  const addItem    = () => setItems((prev) => [...prev, emptyItem()]);
  const removeItem = (key) => setItems((prev) => prev.filter((it) => it._key !== key));

  // ── Extraer datos del archivo con IA (reusa extraer_orden.php) ─────────────
  const handleExtraer = async () => {
    if (!docExtraer || extrayendo) return;
    setExtrayendo(true);
    try {
      const fd = new FormData();
      fd.append("archivo", docExtraer);
      const res = await axios.post(`${BASE}/extraer_orden.php`, fd);
      const { ok, extraido, error: errMsg } = res.data || {};
      if (!ok || !extraido) {
        toast.error(errMsg || "No se pudo leer el archivo.");
        return;
      }
      const filled = new Set();

      if (Array.isArray(extraido.items) && extraido.items.length > 0) {
        setItems(extraido.items.map((it) => ({
          _key: uid(),
          category:     String(it.categoria_id_sugerida ?? ""),
          description:  it.descripcion ?? "",
          quantity:     String(it.cantidad ?? ""),
          price:        String(it.precio_unitario ?? ""),
          number:       "",
          observations: "",
          esEscala:     false,
          escalones:    [],
        })));
        filled.add("items");
      }
      if (extraido.cliente_id_sugerido) {
        setInputClient(String(extraido.cliente_id_sugerido));
        setInputContact("");
        filled.add("cliente");
      }
      if (extraido.notas) {
        setInputObservations(extraido.notas);
        filled.add("obs");
      }
      setExtractedFields(filled);

      if (filled.size === 0) {
        toast.info("No se encontraron datos para precargar en el archivo.");
      } else if (extraido.confianza === "baja") {
        toast.warn("Datos precargados con confianza baja — revisalos bien antes de guardar.");
      } else {
        toast.success("✨ Datos precargados — revisá antes de guardar.");
      }
    } catch {
      toast.error("Error al procesar el archivo.");
    } finally {
      setExtrayendo(false);
    }
  };

  // ── Helpers de escala ──────────────────────────────────────────────────────
  const toggleEscala = (key) =>
    setItems((prev) => prev.map((it) =>
      it._key === key
        ? { ...it, esEscala: !it.esEscala, escalones: !it.esEscala && it.escalones.length === 0 ? [emptyEscalon()] : it.escalones }
        : it
    ));
  const addEscalon = (key) =>
    setItems((prev) => prev.map((it) =>
      it._key === key ? { ...it, escalones: [...it.escalones, emptyEscalon()] } : it
    ));
  const removeEscalon = (key, ek) =>
    setItems((prev) => prev.map((it) =>
      it._key === key ? { ...it, escalones: it.escalones.filter((e) => e._k !== ek) } : it
    ));
  const updateEscalon = (key, ek, field, value) =>
    setItems((prev) => prev.map((it) =>
      it._key === key
        ? { ...it, escalones: it.escalones.map((e) => (e._k === ek ? { ...e, [field]: value } : e)) }
        : it
    ));

  // ── Total (solo ítems NO escala; los escala no suman) ───────────────────────
  const hayEscala = items.some((it) => it.esEscala);
  const total = items
    .filter((it) => !it.esEscala)
    .reduce((sum, it) => sum + (parseFloat(it.quantity) || 0) * (parseFloat(it.price) || 0), 0)
    .toFixed(2);

  // ── Archivos ───────────────────────────────────────────────────────────────
  const handleFiles = (e) => setFiles((prev) => [...prev, ...Array.from(e.target.files)]);
  const removeFile = (idx) => setFiles((prev) => prev.filter((_, i) => i !== idx));
  const fileName = (f) => (f instanceof File ? f.name : f.nombre ?? f.name ?? "");

  // ── Validación ─────────────────────────────────────────────────────────────
  const validate = () => {
    if (!inputClient || !inputProvider) { toast.error("Seleccioná cliente y proveedor."); return false; }
    if (!inputContact) { toast.error("Seleccioná una persona de contacto."); return false; }
    const valid = items.filter((it) => {
      if (!it.description.trim() || !it.category) return false;
      if (it.esEscala) {
        return it.escalones.some((e) => e.cantidad && e.precio);
      }
      return !!it.quantity;
    });
    if (valid.length === 0) { toast.error("Agregá al menos un producto con categoría, descripción y cantidad (o escalones)."); return false; }
    // Cada ítem escala debe tener todos los escalones completos
    for (const it of valid) {
      if (it.esEscala) {
        const completos = it.escalones.filter((e) => e.cantidad && e.precio);
        if (completos.length === 0) {
          toast.error(`"${it.description}": agregá al menos un escalón con cantidad y precio.`);
          return false;
        }
      }
    }
    return valid;
  };

  // ── Submit: CREAR ──────────────────────────────────────────────────────────
  const handleCreate = async () => {
    const validResult = validate();
    if (!validResult) return;
    setSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("cliente_id",    inputClient);
      formData.append("proveedor_id",  inputProvider);
      formData.append("contacto_id",   inputContact);
      formData.append("Observaciones", inputObservations);
      formData.append("user_id",       user.id);
      formData.append("totalAmount",   total);
      formData.append("moneda",        moneda);
      formData.append("tipo_cambio",   moneda === "USD" ? tipoCambio : "");
      formData.append("source",        "newQuotation");
      files.forEach((f, i) => formData.append(`file_${i}`, f));

      const orderItems = validResult.map((it) => {
        const escalonesValidos = it.esEscala
          ? it.escalones
              .filter((e) => e.cantidad && e.precio)
              .map((e) => ({ cantidad: parseFloat(e.cantidad), precio: parseFloat(e.precio) }))
          : [];
        // Para ítem escala: usar el primer escalón como cantidad/precio placeholder
        const qtyBase   = it.esEscala ? (escalonesValidos[0]?.cantidad ?? 0) : (parseFloat(it.quantity) || 0);
        const priceBase = it.esEscala ? (escalonesValidos[0]?.precio   ?? 0) : (parseFloat(it.price) || 0);
        return {
          quantity:     qtyBase,
          price:        priceBase,
          description:  it.description,
          date:         "",
          code:         "",
          number:       it.number,
          observations: it.observations,
          user_id:      user.id,
          category:     it.category,
          esEscala:     it.esEscala,
          escalones:    escalonesValidos,
        };
      });
      formData.append("entregasMultiples", "0");
      formData.append("orderItems",        JSON.stringify(orderItems));
      formData.append("fechaEntrega",      "");

      const res = await axios.post(`${BASE}/checkoutOrder.php`, formData);
      if (res.data[0] === "Solicitud enviada correctamente") {
        // Si vino de una solicitud, marcarla como aceptada y linkearla a la nueva orden
        const newOrdenId = res.data[1];
        if (solicitudId && newOrdenId) {
          try {
            await axios.post(
              `${BASE}/solicitudes_aceptar.php`,
              new URLSearchParams({ id: solicitudId, orden_id: newOrdenId })
            );
          } catch (err) {
            console.warn("solicitudes_aceptar.php failed:", err);
            // No bloqueamos si esto falla — la orden ya quedó creada
          }
        }
        toast.success("¡Cotización creada!");
        history.push("/dashboard/cotizaciones");
      } else {
        toast.error("Error al crear la cotización.");
      }
    } catch {
      toast.error("Error de conexión.");
    } finally {
      setSubmitting(false);
    }
  };

  // ── Submit: EDITAR ─────────────────────────────────────────────────────────
  const handleUpdate = async () => {
    const validItems = validate();
    if (!validItems) return;
    setSubmitting(true);
    try {
      const orderItems = validItems.map((it) => {
        const escalonesValidos = it.esEscala
          ? it.escalones.filter(e => e.cantidad && e.precio).map(e => ({
              cantidad: parseFloat(e.cantidad),
              precio:   parseFloat(e.precio),
            }))
          : [];
        const qtyBase   = it.esEscala ? (escalonesValidos[0]?.cantidad ?? 0) : parseFloat(it.quantity);
        const priceBase = it.esEscala ? (escalonesValidos[0]?.precio   ?? 0) : (parseFloat(it.price) || 0);
        return {
          quantity:     qtyBase,
          price:        priceBase,
          description:  it.description,
          number:       it.number,
          observations: it.observations,
          category:     it.category,
          esEscala:     it.esEscala,
          escalones:    escalonesValidos,
        };
      });

      const formData = new FormData();
      formData.append("orderId",      orderId);
      formData.append("cliente_id",   inputClient);
      formData.append("proveedor_id", inputProvider);
      formData.append("contacto_id",  inputContact);
      formData.append("observaciones", inputObservations);
      formData.append("orderItems",   JSON.stringify(orderItems));
      formData.append("totalAmount",  total);
      formData.append("user_id",      user.id);
      files.filter((f) => f instanceof File).forEach((f, i) => formData.append(`file_${i}`, f));

      const res = await axios.post(`${BASE}/editar_orden_completa.php`, formData);
      if (res.data.success) {
        toast.success("¡Cotización actualizada!");
        history.push("/dashboard/cotizaciones");
      } else {
        toast.error(res.data.message || "Error al actualizar.");
      }
    } catch {
      toast.error("Error de conexión.");
    } finally {
      setSubmitting(false);
    }
  };

  // ── Render ─────────────────────────────────────────────────────────────────
  if (loadingEdit) {
    return (
      <section style={S.page}>
        <div style={S.card}>
          <div style={S.header}><h2 style={S.headerTitle}>Editar Cotización</h2></div>
          <p style={{ textAlign: "center", padding: 48, color: "#aaa" }}>Cargando datos...</p>
        </div>
      </section>
    );
  }

  return (
    <section style={S.page}>
      <div style={S.card}>
        {/* Header */}
        <div style={S.header}>
          <div>
            <h2 style={S.headerTitle}>{editMode ? "Editar Cotización" : "Nueva Cotización"}</h2>
            <p style={S.headerSub}>
              {editMode ? "Modificá los datos y guardá los cambios" : "Completá todos los campos y agregá los productos"}
            </p>
          </div>
        </div>

        <div style={S.body}>
          {/* ── Datos generales ── */}
          <div style={S.section}>
            <p style={S.sectionTitle}>Datos generales</p>
            <div style={S.grid2}>
              <div style={S.fieldGroup}>
                <label style={S.label}>Cliente</label>
                <select style={{ ...S.select, ...aiStyle("cliente") }} value={inputClient} onChange={(e) => { setInputClient(e.target.value); setInputContact(""); clearExtracted("cliente"); }}>
                  <option value="">Seleccioná un cliente</option>
                  {clients.map((c) => (
                    <option key={c.id} value={c.id}>{c.tercero}</option>
                  ))}
                </select>
              </div>

              <div style={S.fieldGroup}>
                <label style={S.label}>Proveedor</label>
                <select style={S.select} value={inputProvider} onChange={(e) => setInputProvider(e.target.value)}>
                  <option value="">Seleccioná un proveedor</option>
                  {providers.map((p) => (
                    <option key={p.id} value={p.id}>{p.tercero}</option>
                  ))}
                </select>
              </div>
            </div>

            <div style={{ ...S.fieldGroup, marginTop: 16 }}>
              <label style={S.label}>
                Contacto *
                {inputClient && contacts.length === 0 && (
                  <span style={{ color: "#f59e0b", fontWeight: 400, marginLeft: 8 }}>
                    — Este cliente no tiene contactos cargados en el CRM
                  </span>
                )}
              </label>
              <select
                style={{ ...S.select, borderColor: !inputContact && inputClient ? "#f59e0b" : "#e0d6dc" }}
                value={inputContact}
                onChange={(e) => setInputContact(e.target.value)}
                disabled={!inputClient || contacts.length === 0}
              >
                <option value="">
                  {!inputClient ? "Primero seleccioná un cliente" : contacts.length === 0 ? "Sin contactos disponibles" : "Seleccioná un contacto"}
                </option>
                {contacts.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.nombre}{c.cargo ? ` — ${c.cargo}` : ""}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ marginTop: 16 }}>
              <label style={S.label}>Observaciones</label>
              <textarea
                style={{ ...S.textarea, ...aiStyle("obs") }}
                placeholder="Notas adicionales sobre esta cotización..."
                value={inputObservations}
                onChange={(e) => { setInputObservations(e.target.value); clearExtracted("obs"); }}
              />
            </div>
          </div>

          {/* ── Moneda (solo en modo creación) ── */}
          {!editMode && (
            <div style={S.section}>
              <p style={S.sectionTitle}>Moneda</p>
              <div style={{ display: "flex", gap: 8 }}>
                {["ARS", "USD"].map((m) => (
                  <button
                    key={m}
                    type="button"
                    onClick={() => handleMonedaChange(m)}
                    style={{
                      padding: "7px 20px", borderRadius: 7, fontWeight: 700, fontSize: 13,
                      cursor: "pointer", border: "1.5px solid",
                      background: moneda === m ? (m === "USD" ? "#fffbeb" : "#fdf0f6") : "#fff",
                      borderColor: moneda === m ? (m === "USD" ? "#f59e0b" : "#9f0059") : "#e0d6dc",
                      color: moneda === m ? (m === "USD" ? "#92400e" : "#9f0059") : "#555",
                    }}
                  >
                    {m === "ARS" ? "$ ARS" : "U$D USD"}
                  </button>
                ))}
              </div>
              {moneda === "USD" && (
                <div style={{ marginTop: 10, padding: "12px 14px", background: "#fffbeb", borderRadius: 8, border: "1.5px solid #fcd34d" }}>
                  <label style={{ ...S.label, color: "#92400e" }}>Tipo de cambio BNA vendedor (editable)</label>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4 }}>
                    <span style={{ fontSize: 14, color: "#92400e", fontWeight: 600 }}>$</span>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="Ej: 1035.50"
                      value={tipoCambio}
                      onChange={(e) => setTipoCambio(e.target.value)}
                      style={{ ...S.input, width: 130, borderColor: "#fcd34d", background: "#fff" }}
                    />
                    <button
                      type="button"
                      onClick={fetchTipoCambio}
                      disabled={loadingTC}
                      style={{
                        padding: "7px 14px", borderRadius: 7, fontSize: 12, fontWeight: 700,
                        cursor: loadingTC ? "default" : "pointer",
                        background: loadingTC ? "#f0e6ec" : "#9f0059", color: loadingTC ? "#bbb" : "#fff",
                        border: "none",
                      }}
                    >
                      {loadingTC ? "Cargando…" : "↻ Actualizar"}
                    </button>
                  </div>
                  {tcFecha && (
                    <div style={{ fontSize: 11, color: "#92400e", marginTop: 5, opacity: 0.8 }}>
                      BNA vendedor {tcFecha} — actualizado automáticamente
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* ── Leer archivo del proveedor (IA) ── */}
          {!editMode && (
            <div style={S.section}>
              <p style={S.sectionTitle}>✨ Leer archivo del proveedor</p>
              <p style={{ fontSize: 12.5, color: "#888", margin: "0 0 12px" }}>
                Subí el PDF o imagen que te mandó el proveedor y la IA precarga los productos (y cliente/notas si los detecta). Después revisás y ajustás.
              </p>
              {!docExtraer ? (
                <label style={{
                  display: "flex", alignItems: "center", gap: 10, cursor: "pointer",
                  border: "1.5px dashed #c990b0", borderRadius: 10, padding: "14px 16px",
                  color: "#9f0059", fontSize: 13, fontWeight: 600, background: "#fdf5fa",
                }}>
                  <FaFileUpload size={18} />
                  Subir archivo (PDF, imagen)
                  <input type="file" accept=".pdf,.png,.jpg,.jpeg" style={{ display: "none" }}
                    onChange={(e) => e.target.files[0] && setDocExtraer(e.target.files[0])} />
                </label>
              ) : (
                <div style={{
                  display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap",
                  border: "1.5px solid #bbf7d0", borderRadius: 10, padding: "12px 16px", background: "#f0fdf4",
                }}>
                  <span style={{ fontSize: 20 }}>📄</span>
                  <span style={{ flex: 1, minWidth: 120, fontSize: 13, color: "#166534", fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {docExtraer.name}
                  </span>
                  <button type="button" onClick={handleExtraer} disabled={extrayendo}
                    style={{ padding: "8px 16px", borderRadius: 8, border: "none", fontWeight: 700, fontSize: 13,
                      cursor: extrayendo ? "wait" : "pointer", background: extrayendo ? "#cbb3c2" : "#9f0059", color: "#fff" }}>
                    {extrayendo ? "Extrayendo…" : "✨ Extraer datos"}
                  </button>
                  <button type="button" onClick={() => setDocExtraer(null)} disabled={extrayendo}
                    style={{ padding: "8px 14px", borderRadius: 8, border: "1.5px solid #e0d6dc", background: "#fff", color: "#666", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                    Cambiar
                  </button>
                </div>
              )}
            </div>
          )}

          {/* ── Productos ── */}
          <div style={S.section}>
            <p style={S.sectionTitle}>Productos</p>
            {extractedFields.has("items") && (
              <div style={{ marginBottom: 10, padding: "6px 14px", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 6, fontSize: 12, color: "#166534", fontWeight: 600 }}>
                ✨ Productos precargados por IA — revisá descripciones, cantidades y precios antes de guardar
              </div>
            )}
            <div style={S.tableWrap}>
              <table style={S.table}>
                <ItemTableHeader />
                <tbody>
                  {items.map((it) => (
                    <ItemRow
                      key={it._key}
                      it={it}
                      categories={categories}
                      canDelete={items.length > 1}
                      onUpdate={(field, val) => updateItem(it._key, field, val)}
                      onDelete={() => removeItem(it._key)}
                      onToggleEscala={() => toggleEscala(it._key)}
                      onAddEscalon={() => addEscalon(it._key)}
                      onRemoveEscalon={(ek) => removeEscalon(it._key, ek)}
                      onUpdateEscalon={(ek, field, val) => updateEscalon(it._key, ek, field, val)}
                      showPricing={!!pricingCategoriaId && String(it.category) === String(pricingCategoriaId) && moneda === "ARS"}
                      onPricing={(escalonKey, cant) => setPricingTarget({ itemKey: it._key, escalonKey, cantidad: cant })}
                    />
                  ))}
                </tbody>
              </table>
            </div>
            <button style={S.addRowBtn} onClick={addItem}>
              <MdAdd size={16} /> Agregar producto
            </button>
          </div>

          {/* ── Archivos ── */}
          <div style={S.section}>
            <p style={S.sectionTitle}>Archivos adjuntos</p>
            <label style={S.fileZone}>
              <FaFileUpload size={18} />
              Subir archivos (PDF, imágenes)
              <input type="file" multiple accept=".pdf,.png,.jpg,.jpeg" style={{ display: "none" }} onChange={handleFiles} />
            </label>
            {files.length > 0 && (
              <div style={S.fileList}>
                {files.map((f, i) => (
                  <div key={i} style={S.fileChip}>
                    {fileName(f)}
                    <button
                      style={{ background: "none", border: "none", cursor: "pointer", color: "#9f0059", padding: 0, display: "flex", alignItems: "center" }}
                      onClick={() => removeFile(i)}
                    >
                      <MdDelete size={14} />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div style={S.footer}>
          <div>
            <p style={S.totalLabel}>Total estimado</p>
            <p style={S.total}>
              {!editMode && moneda === "USD" ? "USD " : "$"}
              {parseFloat(total).toLocaleString("es-AR", { minimumFractionDigits: 2 })}
            </p>
            {!editMode && moneda === "USD" && tipoCambio && parseFloat(tipoCambio) > 0 && (
              <p style={{ fontSize: 12, color: "#92400e", margin: "2px 0 0" }}>
                ≈ ${(parseFloat(total) * parseFloat(tipoCambio)).toLocaleString("es-AR", { minimumFractionDigits: 0 })} ARS
              </p>
            )}
            {hayEscala && (
              <p style={{ fontSize: 12, color: "#9f0059", margin: "2px 0 0", fontWeight: 600 }}>
                ⚖ Incluye ítems en escala (sin total)
              </p>
            )}
          </div>
          <div>
            <button style={S.btnSecondary} onClick={() => history.push("/dashboard/cotizaciones")}>
              Cancelar
            </button>
            <button
              style={{ ...S.btnPrimary, opacity: submitting ? 0.7 : 1, cursor: submitting ? "not-allowed" : "pointer" }}
              onClick={editMode ? handleUpdate : handleCreate}
              disabled={submitting}
            >
              {submitting ? "Guardando..." : editMode ? "Guardar cambios" : "Crear cotización"}
            </button>
          </div>
        </div>
      </div>

      {/* Popup del motor de precios (separadores) */}
      {pricingTarget && (
        <PricingModal
          cantidadInicial={pricingTarget.cantidad}
          onUsar={(precio) => {
            if (pricingTarget.escalonKey) {
              updateEscalon(pricingTarget.itemKey, pricingTarget.escalonKey, "precio", String(precio));
            } else {
              updateItem(pricingTarget.itemKey, "price", String(precio));
            }
            setPricingTarget(null);
          }}
          onClose={() => setPricingTarget(null)}
        />
      )}
    </section>
  );
};

export default NewQuotation;
